import React, { Component } from "react";
import { Tabs } from "antd";
import Content from "./Content";
import SideNav from "../SideNav";

const TabPane = Tabs.TabPane;

const tabs = [{
    tab:'全权启动',
    key:'fullStart',
},{
    tab:'主导启动',
    key:'dominantStart',
},{
    tab:'深度协助',
    key:'deepAssist',
},{
    tab:'基础协助',
    key:'basicAssist',
}]

class SiteStartServiceFeePercent extends Component {
    state = {
        activeKey: 'fullStart',
        siteStartType: 'start_plenipotentiary',
    }

    handleTabClick = key => {
        let type = '';
        switch (key) {
            case 'fullStart':
                type = 'start_plenipotentiary';
                break;
            case 'dominantStart':
                type = 'start_leading';
                break;
            case 'deepAssist':
                type = 'start_deeply_assist';
                break;
            case 'basicAssist':
                type = 'start_ordinary_assist';
                break;
        }
        this.setState({ 
            activeKey: key,
            siteStartType: type,
        });
    }

    render() {
        const { activeKey, siteStartType } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="siteStartServiceFeePercent" />
                <div className='main'>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    <Content siteStartType={siteStartType}/>
                </div>
            </div>
        )
    }
}

export default SiteStartServiceFeePercent;



// WEBPACK FOOTER //
// ./src/components/businessOffer/siteStartServiceFeePercent/index.js